import React, { FC, useState, useEffect } from 'react';
import { RouteComponentProps, Link } from 'react-router-dom';
import { Button } from '@material-ui/core';
import styles from '../../styledComponents';
import Barcode from '../../components/barcode';
import Loader from '../../components/loader';
import { API_URL } from '../../constants';
import axios from '../../utils/axios';
const { PageWrapper, HeaderWrapper, FancyForm, TextInput, FlexWrapper, Error } = styles;

interface BarcodeState {
  sku: string;
  hideSearch: boolean;
  title: string;
  text: string;
  error: string;
  loading: boolean;
}

interface CreateBarcodeProps {
  sku?: string;
  hideSearch?: boolean;
}

const CreateBarcode: FC<Partial<RouteComponentProps> & CreateBarcodeProps> = ({
  location,
  sku: skuProp,
  hideSearch: hideSearchProp,
}) => {
  const search = location?.search ?? '';
  const skuParam = skuProp || new URLSearchParams(search).get('sku');
  const hsParam = hideSearchProp || new URLSearchParams(search).get('hideSearch') === 'true';

  const initialState: BarcodeState = {
    sku: skuParam ?? '',
    hideSearch: hsParam ?? false,
    title: '',
    text: '',
    error: '',
    loading: false,
  };
  const [{ title, text, sku, hideSearch, loading, error }, setState] = useState(initialState);

  const updateState = (state: string, value: any) => {
    setState(prevState => ({ ...prevState, [state]: value }));
  };
  const handleChange = (e: any) => {
    const { name, value } = e.currentTarget;
    updateState(name, value);
  };
  const getItemInfo = async () => {
    try {
      updateState('loading', true);
      const options = {
        params: {
          sku: sku,
          hideSearch: hideSearch,
        },
      };
      const res = await axios.get(`${API_URL}/service/itemInfo`, options);
      if (res && res.data?.sku) {
        const { displayName, variation } = res.data;
        updateState('title', `${displayName}${variation ? ` (${variation})` : ''}`);
        updateState('text', res.data.sku);
      }
    } catch (err) {
      if (err?.response?.data?.message) {
        updateState('error', err?.response?.data?.message);
      } else {
        updateState('error', err.message);
      }
    }
    updateState('loading', false);
  };

  // NOTE: if we have an initial SKU from params generate barcode for that SKU
  useEffect(() => {
    if (skuParam) {
      getItemInfo();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [skuParam]);

  const handleSubmit = (e: any) => {
    e.preventDefault();
    updateState('error', '');
    getItemInfo();
  };
  return (
    <PageWrapper>
      {!hideSearch && (
        <>
          <HeaderWrapper>
            Create Barcode
            <Button to="/catalog/upc/" variant="contained" component={Link}>
              Create Barcode by UPC
            </Button>
          </HeaderWrapper>
          <FancyForm onSubmit={handleSubmit}>
            <TextInput placeholder="Enter sku..." name="sku" onChange={handleChange} value={sku} />
            <Button variant="contained" type="submit" size="large">
              Lookup SKU
            </Button>
            <Error>{error}</Error>
          </FancyForm>
        </>
      )}
      <FlexWrapper justifyContent="center" padding="20px 0">
        {text && <Barcode text={text} title={title}></Barcode>}
      </FlexWrapper>
      <Loader loading={loading}></Loader>
    </PageWrapper>
  );
};

export default CreateBarcode;
